import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Controls } from './controls/Controls';
import Modal from './Modal';

export default function ImportSettingsModal({ isOpen, handleClose, onImport }) {
  const [jsonText, setJsonText] = useState('');
  const [error, setError] = useState('');

  const validateJson = (text) => {
    try {
      const parsed = JSON.parse(text);
      if (!parsed.settings || !Array.isArray(parsed.settings)) {
        return 'JSON must have a &quot;settings&quot; key with an array value';
      }

      const hasInvalidSettings = parsed.settings.some(
        (setting) => !setting.name || !setting.value || !setting.category,
      );

      if (hasInvalidSettings) {
        return 'Each setting must have &quot;name&quot;, &quot;value&quot;, and &quot;category&quot; properties';
      }

      return null;
    } catch (e) {
      return 'Invalid JSON format';
    }
  };

  const handleTextChange = (e) => {
    const text = e.target.value;
    setJsonText(text);
    setError(validateJson(text));
  };

  const handleSubmit = () => {
    const validationError = validateJson(jsonText);
    if (validationError) {
      setError(validationError);
      return;
    }

    const parsed = JSON.parse(jsonText);
    onImport(parsed.settings);
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Import Settings"
    >
      <div style={{ padding: '20px' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Paste the exported settings below
        </Typography>
        <Controls.Input
          multiline
          rows={10}
          fullWidth
          value={jsonText}
          onChange={handleTextChange}
          error={!!error}
          helperText={error}
          sx={{ mb: 3 }}
        />
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
        }}
        >
          <Controls.Button
            text="Cancel"
            variant="outlined"
            onClick={handleClose}
          />
          <Controls.Button
            text="Import"
            variant="contained"
            onClick={handleSubmit}
            disabled={!!error || !jsonText.trim()}
          />
        </div>
      </div>
    </Modal>
  );
}

ImportSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
};
